export default __webpack_public_path__ + "static/media/ul_snozowy.9727cf5f.svg";